<template>
  <div class="d-flex align-items-center justify-content-start">
    <span class>
      <ImageBox
        :downloadCode="downloadCode"
        :defaultImage="defaultImage"
        imageClass="width-50 height-50 rounded-circle"
        wrapperClass="flex-center"
        loadingClass="left-4 width-50 height-50 rounded-circle"
      />
    </span>

    <div class="font_14 ml-2 d-flex flex-column text-left">
      <u>
        <ProfileBoxPopupWrapper
          :data="generateAvatarInfoData"
          deskTopPopupClass="top-230"
          nameClass="color-complementary"
        />
      </u>
      <span v-text="description" class="text-left mt-2 color_black" />
    </div>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "../re-design";
import ImageBox from "../re-design/image-box/ImageBox.vue";
import { generateConfig } from "@/shared/utils";

export default {
  components: { ProfileBoxPopupWrapper, ImageBox },
  props: {
    type: {
      type: String,
      default: "person",
    },
    personCode: {
      type: [String, Number],
      default: null,
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    downloadCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showImageModal: false,
      imageSrc: "",
    };
  },
  computed: {
    onErrorImage() {
      return this.type === "person"
        ? this.$config.images.shared.noPerson
        : this.$config.images.shared.noImage;
    },
    generateAvatarInfoData() {
      return {
        downloadCode: this.downloadCode,
        parvandeh_code: this.parvandehCode,
        person_code: this.personCode,
        image_address: this.imageSrc,
        full_name: this.title,
      };
    },
    defaultImage() {
      return generateConfig([
        "images",
        "shared",
        "redesign",
        "empty",
        "noUser",
      ]);
    },
  },
};
</script>
